import React, { Fragment, useRef, useEffect, useState } from 'react'
import Icon from 'shared/ui/Icon'
import Heading from 'shared/ui/Heading'
import { SimpleForm } from 'shared/ui/SimpleForm'
import classnames from 'classnames'
import subscribeToMailingList from '../utils/subscribeToMailingList'
import './NewsletterSubscribeForm.scss'

export function NewsletterSubscribeSection(props) {
  return (
    <section className="newsletter-subscribe-section spacing">
      <Heading size={3}>Subscribe to our Blog and Newsletter</Heading>
      <p className="text-small">Don't worry, we don't send emails too often.</p>
      <NewsletterSubscribeForm {...props} />
    </section>
  )
}

export function NewsletterSubscribeForm({ focus = false }) {
  function handleSubmit({ email }) {
    return subscribeToMailingList('852704', { email })
  }

  const inputRef = useRef()

  useEffect(() => {
    if (focus) {
      inputRef.current.focus()
    }
  }, [focus])

  const [inputFocused, setInputFocused] = useState(false)

  return (
    <SimpleForm onSubmit={handleSubmit} showNotice={false}>
      {({ status }) => {
        return (
          <div
            className={classnames('newsletter-subscribe-input', {
              'newsletter-subscribe-input-focused': inputFocused,
            })}
          >
            {status === 'idle' && (
              <Fragment>
                <Icon name="react" color="brightBlue" />
                <input
                  type="text"
                  className="input-content"
                  name="email"
                  ref={inputRef}
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                  aria-label="Your email address"
                  placeholder="jane@example.com"
                />
                <button type="submit" className="button">
                  Subscribe
                </button>
              </Fragment>
            )}
            {status === 'loading' && (
              <div className="success">
                <span role="img" aria-label="alarm clock">
                  ⏰
                </span>{' '}
                Loading...
              </div>
            )}
            {status === 'success' && (
              <div className="success">
                <span role="img" aria-label="confetti">
                  🎉
                </span>{' '}
                Yay! You're Subscribed
              </div>
            )}
          </div>
        )
      }}
    </SimpleForm>
  )
}
